((Product, $) => {
  'use strict';

  let $productDescription;
  let $productDescriptionActivation;
  let $productDescriptionParagraph;
  let $modelDescriptionContainer;
  let $modelDescription;
  let $modelDescriptionToggle;
  let $modelDescriptionText;
  let $mainATC;
  let $stickyATC;

  const cacheDom = () => {
    $productDescription = $('.wysiwyg-desktop-only .main-product-description');
    $productDescriptionActivation = $('.product-description-activation');
    $productDescriptionParagraph = $productDescription.find('p');
    $modelDescriptionContainer = $('.js-wysiwyg-container');
    $modelDescription = $modelDescriptionContainer.find('.js-wysiwyg-expand');
    $modelDescriptionToggle = $modelDescriptionContainer.find('.js-wysiwyg-toggle');
    $modelDescriptionText = $modelDescriptionContainer.find('.js-wysiwyg-paragraphs');
    $mainATC = $('.product-add .button-container');
    $stickyATC = $('.js-sticky-add-to-cart');
  };

  const toggleDescription = () => {
    const paragraphHeight = $productDescriptionParagraph.height();

    if ($productDescription.attr('data-description-toggled') === 'false') {
      $productDescription.css('max-height', `${paragraphHeight}px`);
      $productDescriptionActivation.text('Read Less');
      $productDescription.attr('data-description-toggled', 'true');
    } else {
      $productDescription.css('max-height', '95px');
      $productDescriptionActivation.text('Read More');
      $productDescription.attr('data-description-toggled', 'false');
    }
  };

  const bindUIActions = () => {
    $productDescriptionActivation.on('click', (event) => {
      event.preventDefault();
      toggleDescription();
    });

    $(window).on('scroll', () => {
      if ($(window).innerWidth >= 991 && $mainATC.offset) {
        const mainATCTop = $mainATC.offset().top;
        const mainATCBottom = mainATCTop + $mainATC.outerHeight();
        const windowScroll = $(window).scrollTop();
        const adjustedScroll = windowScroll + $('.purchase-bar').offset().top;
        if (adjustedScroll >= mainATCBottom) {
          // show stick atc
          $stickyATC.addClass('is-visible');
        } else {
          // hide sticky atc
          $stickyATC.removeClass('is-visible');
        }
      }
    });

    $modelDescriptionToggle.on('click', function toggleMobileDescription(event) {
      event.preventDefault();
      const $this = $(this);
      const paragraphHeight = $modelDescriptionText.height();

      if ($modelDescription.attr('data-description-toggled') === 'false') {
        $modelDescription.css('max-height', `${paragraphHeight}px`);
        $this.text('Read Less');
        $modelDescription.attr('data-description-toggled', 'true');
      } else {
        $modelDescription.css('max-height', '200px');
        $this.text('Read More');
        $modelDescription.attr('data-description-toggled', 'false');
      }
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  Product.init = init;
})(window.Product = window.Product || {}, jQuery);
